import type { StepProps } from '../OBWWizard';
import { BOW_CONTENT } from '../content/bow';

// ADR-073 Amendment 2 (A2.2) — BOW welcome bookend. Content-driven: all copy is
// read from the BOW content map (the first Flow-Composer content brick, A2.8),
// never hardcoded inline. Mirrors StepWelcome's shell + numbered steps-preview.
export function BowWelcomeStep({ onNext }: StepProps) {
  const c = BOW_CONTENT.welcome;

  return (
    <div className="obw-step-content">
      <h2 className="obw-title">{c.heading}</h2>
      <p className="obw-subtitle">{c.body}</p>

      {c.steps.length > 0 && (
        <ol className="obw-steps-preview" aria-label="What we'll cover">
          {c.steps.map((s) => (
            <li key={s.num}>
              <span className="obw-step-num" aria-hidden="true">{s.num}</span>
              <span>
                <strong style={{ color: 'var(--text)' }}>{s.label}</strong>
                <br />
                <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>{s.description}</span>
              </span>
            </li>
          ))}
        </ol>
      )}

      <p className="obw-subtitle" style={{ fontSize: '14px' }}>{c.footnote}</p>

      <button type="button" className="obw-btn-primary" onClick={() => onNext({})}>
        {c.cta}
      </button>
    </div>
  );
}
